/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './payroll-additional-costs.component.css.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '@angular/forms';
import * as import3 from '../../../../app/booking-management/payroll-additional-costs/payroll-additional-costs.component';
import * as import4 from '@angular/common';
const styles_PayrollAdditionalCostsComponent:any[] = [import0.styles];
export const RenderType_PayrollAdditionalCostsComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_PayrollAdditionalCostsComponent,
  data: {}
}
);
function View_PayrollAdditionalCostsComponent_1(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'span',[[
        'class',
        'inline-icon error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                   '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Oops! Only numerical values, "." and ":" are allowed.'])),
    (l()(),import1.ɵted((null as any),['!\n            ']))
  ]
  ,(null as any),(null as any));
}
function View_PayrollAdditionalCostsComponent_2(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'span',[[
        'class',
        'inline-icon error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                   '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Oops! Only numerical values, "." and ":" are allowed.'])),
    (l()(),import1.ɵted((null as any),['!\n            ']))
  ]
  ,(null as any),(null as any));
}
function View_PayrollAdditionalCostsComponent_3(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'span',[[
        'class',
        'inline-icon error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                   '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Oops! Only numerical values, "." and ":" are allowed.'])),
    (l()(),import1.ɵted((null as any),['!\n            ']))
  ]
  ,(null as any),(null as any));
}
function View_PayrollAdditionalCostsComponent_4(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'span',[[
        'class',
        'inline-icon error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                   '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Oops! Only numerical values, "." and ":" are allowed.'])),
    (l()(),import1.ɵted((null as any),['!\n            ']))
  ]
  ,(null as any),(null as any));
}
export function View_PayrollAdditionalCostsComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    import1.ɵqud(402653184,1,{form: 0}),
    (l()(),import1.ɵeld(0,(null as any),(null as any),88,'footer',[
      [
        'class',
        'payroll-card__footer common-form'
      ]
      ,
      [
        'ngForm',
        'payrollAdditionalCostFields'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'submit'
      ]
      ,
      [
        (null as any),
        'reset'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('submit' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,2).onSubmit($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('reset' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,2).onReset()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,[
      [
        1,
        4
      ]
      ,
      [
        'payrollAdditionalCostFields',
        4
      ]

    ]
    ,0,import2.NgForm,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]

    ]
    ,(null as any),(null as any)),
    import1.ɵprd(2048,(null as any),import2.ControlContainer,(null as any),[import2.NgForm]),
    import1.ɵdid(16384,(null as any),0,import2.NgControlStatusGroup,[import2.ControlContainer],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'payroll-card__measure'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'payroll-card__measure-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Transfers'])),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'form-field'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,'input',[
      [
        'class',
        'payroll-card__measure-input'
      ]
      ,
      [
        'pattern',
        '\\$?(\\d+|\\d+(\\.)\\d+)'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        8,
        'readOnly',
        0
      ]
      ,
      [
        8,
        'placeholder',
        0
      ]
      ,
      [
        1,
        'pattern',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import3.PayrollAdditionalCostsComponent = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,14)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,14).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import1.ɵnov(v,14)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import1.ɵnov(v,14)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_4:any = ((<any>(co.payrollInvoice.transfers = $event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import2.DefaultValueAccessor,[
      import1.Renderer,
      import1.ElementRef,
      [
        2,
        import2.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
      import1.ɵdid(540672,(null as any),0,import2.PatternValidator,([] as any[]),{pattern: [
        0,
        'pattern'
      ]
    },(null as any)),
    import1.ɵprd(1024,(null as any),import2.NG_VALIDATORS,(p0_0:any) => {
      return [p0_0];
    },[import2.PatternValidator]),
    import1.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import2.DefaultValueAccessor]),
      import1.ɵdid(671744,[[
        'interpreterTransfers',
        4
      ]
    ],0,import2.NgModel,[
      [
        2,
        import2.ControlContainer
      ]
      ,
      [
        2,
        import2.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import1.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.NgModel]),
    import1.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PayrollAdditionalCostsComponent_1)),
    import1.ɵdid(16384,(null as any),0,import4.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'payroll-card__measure'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'payroll-card__measure-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Meals'])),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'form-field'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,'input',[
      [
        'class',
        'payroll-card__measure-input'
      ]
      ,
      [
        'pattern',
        '\\$?(\\d+|\\d+(\\.|\\:)\\d+)'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        8,
        'readOnly',
        0
      ]
      ,
      [
        8,
        'placeholder',
        0
      ]
      ,
      [
        1,
        'pattern',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import3.PayrollAdditionalCostsComponent = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,35)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,35).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import1.ɵnov(v,35)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import1.ɵnov(v,35)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_4:any = ((<any>(co.payrollInvoice.meals = $event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import2.DefaultValueAccessor,[
      import1.Renderer,
      import1.ElementRef,
      [
        2,
        import2.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
      import1.ɵdid(540672,(null as any),0,import2.PatternValidator,([] as any[]),{pattern: [
        0,
        'pattern'
      ]
    },(null as any)),
    import1.ɵprd(1024,(null as any),import2.NG_VALIDATORS,(p0_0:any) => {
      return [p0_0];
    },[import2.PatternValidator]),
    import1.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import2.DefaultValueAccessor]),
      import1.ɵdid(671744,[[
        'meals',
        4
      ]
    ],0,import2.NgModel,[
      [
        2,
        import2.ControlContainer
      ]
      ,
      [
        2,
        import2.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import1.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.NgModel]),
    import1.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PayrollAdditionalCostsComponent_2)),
    import1.ɵdid(16384,(null as any),0,import4.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'payroll-card__measure'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'payroll-card__measure-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Accom.'])),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'form-field'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,'input',[
      [
        'class',
        'payroll-card__measure-input'
      ]
      ,
      [
        'pattern',
        '\\$?(\\d+|\\d+(\\.|\\:)\\d+)'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        8,
        'readOnly',
        0
      ]
      ,
      [
        8,
        'placeholder',
        0
      ]
      ,
      [
        1,
        'pattern',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import3.PayrollAdditionalCostsComponent = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,56)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,56).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import1.ɵnov(v,56)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import1.ɵnov(v,56)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_4:any = ((<any>(co.payrollInvoice.accommodations = $event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import2.DefaultValueAccessor,[
      import1.Renderer,
      import1.ElementRef,
      [
        2,
        import2.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
      import1.ɵdid(540672,(null as any),0,import2.PatternValidator,([] as any[]),{pattern: [
        0,
        'pattern'
      ]
    },(null as any)),
    import1.ɵprd(1024,(null as any),import2.NG_VALIDATORS,(p0_0:any) => {
      return [p0_0];
    },[import2.PatternValidator]),
    import1.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import2.DefaultValueAccessor]),
      import1.ɵdid(671744,[[
        'accom',
        4
      ]
    ],0,import2.NgModel,[
      [
        2,
        import2.ControlContainer
      ]
      ,
      [
        2,
        import2.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import1.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.NgModel]),
    import1.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PayrollAdditionalCostsComponent_3)),
    import1.ɵdid(16384,(null as any),0,import4.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'payroll-card__measure'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'span',[[
        'class',
        'payroll-card__measure-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Flights'])),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'form-field'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,'input',[
      [
        'class',
        'payroll-card__measure-input'
      ]
      ,
      [
        'pattern',
        '\\$?(\\d+|\\d+(\\.)\\d+)'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        8,
        'readOnly',
        0
      ]
      ,
      [
        8,
        'placeholder',
        0
      ]
      ,
      [
        1,
        'pattern',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import3.PayrollAdditionalCostsComponent = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,77)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,77).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import1.ɵnov(v,77)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import1.ɵnov(v,77)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_4:any = ((<any>(co.payrollInvoice.flights = $event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import2.DefaultValueAccessor,[
      import1.Renderer,
      import1.ElementRef,
      [
        2,
        import2.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
      import1.ɵdid(540672,(null as any),0,import2.PatternValidator,([] as any[]),{pattern: [
        0,
        'pattern'
      ]
    },(null as any)),
    import1.ɵprd(1024,(null as any),import2.NG_VALIDATORS,(p0_0:any) => {
      return [p0_0];
    },[import2.PatternValidator]),
    import1.ɵprd(1024,(null as any),import2.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import2.DefaultValueAccessor]),
      import1.ɵdid(671744,[[
        'flights',
        4
      ]
    ],0,import2.NgModel,[
      [
        2,
        import2.ControlContainer
      ]
      ,
      [
        2,
        import2.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import2.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import1.ɵprd(2048,(null as any),import2.NgControl,(null as any),[import2.NgModel]),
    import1.ɵdid(16384,(null as any),0,import2.NgControlStatus,[import2.NgControl],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PayrollAdditionalCostsComponent_4)),
    import1.ɵdid(16384,(null as any),0,import4.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import3.PayrollAdditionalCostsComponent = v.component;
    const currVal_17:any = '\\$?(\\d+|\\d+(\\.)\\d+)';
    ck(v,15,0,currVal_17);
    const currVal_18:any = import1.ɵinlineInterpolate(1,'',(((co.isClient? 'client_': 'interpreter_') + 'interpreterTransfers_') + co.index),'');
    const currVal_19:any = ((co.payrollInvoice == null)? (null as any): co.payrollInvoice.transfers);
    ck(v,18,0,currVal_18,currVal_19);
    const currVal_20:any = (import1.ɵnov(v,18).touched && ((import1.ɵnov(v,18).errors == null)? (null as any): import1.ɵnov(v,18).errors.pattern));
    ck(v,23,0,currVal_20);
    const currVal_31:any = '\\$?(\\d+|\\d+(\\.|\\:)\\d+)';
    ck(v,36,0,currVal_31);
    const currVal_32:any = import1.ɵinlineInterpolate(1,'',(((co.isClient? 'client_': 'interpreter_') + 'meals_') + co.index),'');
    const currVal_33:any = ((co.payrollInvoice == null)? (null as any): co.payrollInvoice.meals);
    ck(v,39,0,currVal_32,currVal_33);
    const currVal_34:any = (import1.ɵnov(v,39).touched && ((import1.ɵnov(v,39).errors == null)? (null as any): import1.ɵnov(v,39).errors.pattern));
    ck(v,44,0,currVal_34);
    const currVal_45:any = '\\$?(\\d+|\\d+(\\.|\\:)\\d+)';
    ck(v,57,0,currVal_45);
    const currVal_46:any = import1.ɵinlineInterpolate(1,'',(((co.isClient? 'client_': 'interpreter_') + 'accom_') + co.index),'');
    const currVal_47:any = ((co.payrollInvoice == null)? (null as any): co.payrollInvoice.accommodations);
    ck(v,60,0,currVal_46,currVal_47);
    const currVal_48:any = (import1.ɵnov(v,60).touched && ((import1.ɵnov(v,60).errors == null)? (null as any): import1.ɵnov(v,60).errors.pattern));
    ck(v,65,0,currVal_48);
    const currVal_59:any = '\\$?(\\d+|\\d+(\\.)\\d+)';
    ck(v,78,0,currVal_59);
    const currVal_60:any = import1.ɵinlineInterpolate(1,'',(((co.isClient? 'client_': 'interpreter_') + 'flights_') + co.index),'');
    const currVal_61:any = ((co.payrollInvoice == null)? (null as any): co.payrollInvoice.flights);
    ck(v,81,0,currVal_60,currVal_61);
    const currVal_62:any = (import1.ɵnov(v,81).touched && ((import1.ɵnov(v,81).errors == null)? (null as any): import1.ɵnov(v,81).errors.pattern));
    ck(v,86,0,currVal_62);
  },(ck,v) => {
    var co:import3.PayrollAdditionalCostsComponent = v.component;
    const currVal_0:any = import1.ɵnov(v,4).ngClassUntouched;
    const currVal_1:any = import1.ɵnov(v,4).ngClassTouched;
    const currVal_2:any = import1.ɵnov(v,4).ngClassPristine;
    const currVal_3:any = import1.ɵnov(v,4).ngClassDirty;
    const currVal_4:any = import1.ɵnov(v,4).ngClassValid;
    const currVal_5:any = import1.ɵnov(v,4).ngClassInvalid;
    const currVal_6:any = import1.ɵnov(v,4).ngClassPending;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
    const currVal_7:any = co.isReadOnly;
    const currVal_8:any = co.interpTransfersPlaceHolder;
    const currVal_9:any = (import1.ɵnov(v,15).pattern? import1.ɵnov(v,15).pattern: (null as any));
    const currVal_10:any = import1.ɵnov(v,20).ngClassUntouched;
    const currVal_11:any = import1.ɵnov(v,20).ngClassTouched;
    const currVal_12:any = import1.ɵnov(v,20).ngClassPristine;
    const currVal_13:any = import1.ɵnov(v,20).ngClassDirty;
    const currVal_14:any = import1.ɵnov(v,20).ngClassValid;
    const currVal_15:any = import1.ɵnov(v,20).ngClassInvalid;
    const currVal_16:any = import1.ɵnov(v,20).ngClassPending;
    ck(v,13,0,currVal_7,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,currVal_14,currVal_15,currVal_16);
    const currVal_21:any = co.isReadOnly;
    const currVal_22:any = co.mealsPlaceHolder;
    const currVal_23:any = (import1.ɵnov(v,36).pattern? import1.ɵnov(v,36).pattern: (null as any));
    const currVal_24:any = import1.ɵnov(v,41).ngClassUntouched;
    const currVal_25:any = import1.ɵnov(v,41).ngClassTouched;
    const currVal_26:any = import1.ɵnov(v,41).ngClassPristine;
    const currVal_27:any = import1.ɵnov(v,41).ngClassDirty;
    const currVal_28:any = import1.ɵnov(v,41).ngClassValid;
    const currVal_29:any = import1.ɵnov(v,41).ngClassInvalid;
    const currVal_30:any = import1.ɵnov(v,41).ngClassPending;
    ck(v,34,0,currVal_21,currVal_22,currVal_23,currVal_24,currVal_25,currVal_26,currVal_27,currVal_28,currVal_29,currVal_30);
    const currVal_35:any = co.isReadOnly;
    const currVal_36:any = co.accomPlaceHolder;
    const currVal_37:any = (import1.ɵnov(v,57).pattern? import1.ɵnov(v,57).pattern: (null as any));
    const currVal_38:any = import1.ɵnov(v,62).ngClassUntouched;
    const currVal_39:any = import1.ɵnov(v,62).ngClassTouched;
    const currVal_40:any = import1.ɵnov(v,62).ngClassPristine;
    const currVal_41:any = import1.ɵnov(v,62).ngClassDirty;
    const currVal_42:any = import1.ɵnov(v,62).ngClassValid;
    const currVal_43:any = import1.ɵnov(v,62).ngClassInvalid;
    const currVal_44:any = import1.ɵnov(v,62).ngClassPending;
    ck(v,55,0,currVal_35,currVal_36,currVal_37,currVal_38,currVal_39,currVal_40,currVal_41,currVal_42,currVal_43,currVal_44);
    const currVal_49:any = co.isReadOnly;
    const currVal_50:any = co.flightsPlaceHolder;
    const currVal_51:any = (import1.ɵnov(v,78).pattern? import1.ɵnov(v,78).pattern: (null as any));
    const currVal_52:any = import1.ɵnov(v,83).ngClassUntouched;
    const currVal_53:any = import1.ɵnov(v,83).ngClassTouched;
    const currVal_54:any = import1.ɵnov(v,83).ngClassPristine;
    const currVal_55:any = import1.ɵnov(v,83).ngClassDirty;
    const currVal_56:any = import1.ɵnov(v,83).ngClassValid;
    const currVal_57:any = import1.ɵnov(v,83).ngClassInvalid;
    const currVal_58:any = import1.ɵnov(v,83).ngClassPending;
    ck(v,76,0,currVal_49,currVal_50,currVal_51,currVal_52,currVal_53,currVal_54,currVal_55,currVal_56,currVal_57,currVal_58);
  });
}
function View_PayrollAdditionalCostsComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-payroll-additional-costs',([] as any[]),(null as any),(null as any),(null as any),View_PayrollAdditionalCostsComponent_0,RenderType_PayrollAdditionalCostsComponent)),
    import1.ɵdid(114688,(null as any),0,import3.PayrollAdditionalCostsComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const PayrollAdditionalCostsComponentNgFactory:import1.ComponentFactory<import3.PayrollAdditionalCostsComponent> = import1.ɵccf('app-payroll-additional-costs',import3.PayrollAdditionalCostsComponent,View_PayrollAdditionalCostsComponent_Host_0,{
  payrollInvoice: 'payrollInvoice',
  index: 'index',
  isClient: 'isClient',
  parentForm: 'parentForm',
  isReadOnly: 'isReadOnly'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9ib29raW5nLW1hbmFnZW1lbnQvcGF5cm9sbC1hZGRpdGlvbmFsLWNvc3RzL3BheXJvbGwtYWRkaXRpb25hbC1jb3N0cy5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmVyY2VsL3dvcmtwYXRoMC9zcmMvYXBwL2Jvb2tpbmctbWFuYWdlbWVudC9wYXlyb2xsLWFkZGl0aW9uYWwtY29zdHMvcGF5cm9sbC1hZGRpdGlvbmFsLWNvc3RzLmNvbXBvbmVudC50cyIsIm5nOi8vL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9ib29raW5nLW1hbmFnZW1lbnQvcGF5cm9sbC1hZGRpdGlvbmFsLWNvc3RzL3BheXJvbGwtYWRkaXRpb25hbC1jb3N0cy5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9ib29raW5nLW1hbmFnZW1lbnQvcGF5cm9sbC1hZGRpdGlvbmFsLWNvc3RzL3BheXJvbGwtYWRkaXRpb25hbC1jb3N0cy5jb21wb25lbnQudHMuUGF5cm9sbEFkZGl0aW9uYWxDb3N0c0NvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxmb290ZXIgY2xhc3M9XCJwYXlyb2xsLWNhcmRfX2Zvb3RlciBjb21tb24tZm9ybVwiIG5nRm9ybT1cInBheXJvbGxBZGRpdGlvbmFsQ29zdEZpZWxkc1wiICNwYXlyb2xsQWRkaXRpb25hbENvc3RGaWVsZHM9XCJuZ0Zvcm1cIj5cbiAgICA8ZGl2IGNsYXNzPVwicGF5cm9sbC1jYXJkX19tZWFzdXJlXCI+XG4gICAgICAgIDxzcGFuIGNsYXNzPVwicGF5cm9sbC1jYXJkX19tZWFzdXJlLW5hbWVcIj5UcmFuc2ZlcnM8L3NwYW4+XG4gICAgICAgIDxkaXYgY2xhc3M9XCJmb3JtLWZpZWxkXCI+XG4gICAgICAgICAgICA8aW5wdXQgdHlwZT1cInRleHRcIiBuYW1lPVwie3soaXNDbGllbnQgPyAnY2xpZW50XycgOiAnaW50ZXJwcmV0ZXJfJykgKyAnaW50ZXJwcmV0ZXJUcmFuc2ZlcnNfJyArIGluZGV4fX1cIiAjaW50ZXJwcmV0ZXJUcmFuc2ZlcnM9XCJuZ01vZGVsXCIgW3JlYWRvbmx5XT1cImlzUmVhZE9ubHlcIlxuICAgICAgICAgICAgICAgICAgIFtwbGFjZWhvbGRlcl09XCJpbnRlcnBUcmFuc2ZlcnNQbGFjZUhvbGRlclwiIGNsYXNzPVwicGF5cm9sbC1jYXJkX19tZWFzdXJlLWlucHV0XCIgW25nTW9kZWxdPVwicGF5cm9sbEludm9pY2U/LnRyYW5zZmVyc1wiXG4gICAgICAgICAgICAgICAgICAgKG5nTW9kZWxDaGFuZ2UpPVwicGF5cm9sbEludm9pY2UudHJhbnNmZXJzID0gJGV2ZW50XCJcbiAgICAgICAgICAgICAgICAgICBwYXR0ZXJuPVwiXFwkPyhcXGQrfFxcZCsoXFwuKVxcZCspXCI+XG4gICAgICAgICAgICA8c3BhbiAqbmdJZj1cImludGVycHJldGVyVHJhbnNmZXJzLnRvdWNoZWQgJiYgKGludGVycHJldGVyVHJhbnNmZXJzLmVycm9ycz8ucGF0dGVybik7XCJcbiAgICAgICAgICAgICAgICAgICBjbGFzcz1cImlubGluZS1pY29uIGVycm9yXCI+XG4gICAgICAgICAgICAgICAgICAgPHNwYW4+T29wcyEgT25seSBudW1lcmljYWwgdmFsdWVzLCBcIi5cIiBhbmQgXCI6XCIgYXJlIGFsbG93ZWQuPC9zcGFuPiFcbiAgICAgICAgICAgIDwvc3Bhbj5cbiAgICAgICAgPC9kaXY+XG4gICAgPC9kaXY+XG4gICAgPGRpdiBjbGFzcz1cInBheXJvbGwtY2FyZF9fbWVhc3VyZVwiPlxuICAgICAgICA8c3BhbiBjbGFzcz1cInBheXJvbGwtY2FyZF9fbWVhc3VyZS1uYW1lXCI+TWVhbHM8L3NwYW4+XG4gICAgICAgIDxkaXYgY2xhc3M9XCJmb3JtLWZpZWxkXCI+XG4gICAgICAgICAgICA8aW5wdXQgdHlwZT1cInRleHRcIiBuYW1lPVwie3soaXNDbGllbnQgPyAnY2xpZW50XycgOiAnaW50ZXJwcmV0ZXJfJykgKyAnbWVhbHNfJyArIGluZGV4fX1cIiAjbWVhbHM9XCJuZ01vZGVsXCIgW3JlYWRvbmx5XT1cImlzUmVhZE9ubHlcIlxuICAgICAgICAgICAgICAgICAgIFtwbGFjZWhvbGRlcl09XCJtZWFsc1BsYWNlSG9sZGVyXCIgY2xhc3M9XCJwYXlyb2xsLWNhcmRfX21lYXN1cmUtaW5wdXRcIiBbbmdNb2RlbF09XCJwYXlyb2xsSW52b2ljZT8ubWVhbHNcIlxuICAgICAgICAgICAgICAgICAgIChuZ01vZGVsQ2hhbmdlKT1cInBheXJvbGxJbnZvaWNlLm1lYWxzID0gJGV2ZW50XCJcbiAgICAgICAgICAgICAgICAgICBwYXR0ZXJuPVwiXFwkPyhcXGQrfFxcZCsoXFwufFxcOilcXGQrKVwiPlxuICAgICAgICAgICAgPHNwYW4gKm5nSWY9XCJtZWFscy50b3VjaGVkICYmIChtZWFscy5lcnJvcnM/LnBhdHRlcm4pO1wiXG4gICAgICAgICAgICAgICAgICAgY2xhc3M9XCJpbmxpbmUtaWNvbiBlcnJvclwiPlxuICAgICAgICAgICAgICAgICAgIDxzcGFuPk9vcHMhIE9ubHkgbnVtZXJpY2FsIHZhbHVlcywgXCIuXCIgYW5kIFwiOlwiIGFyZSBhbGxvd2VkLjwvc3Bhbj4hXG4gICAgICAgICAgICA8L3NwYW4+XG4gICAgICAgIDwvZGl2PlxuICAgIDwvZGl2PlxuICAgIDxkaXYgY2xhc3M9XCJwYXlyb2xsLWNhcmRfX21lYXN1cmVcIj5cbiAgICAgICAgPHNwYW4gY2xhc3M9XCJwYXlyb2xsLWNhcmRfX21lYXN1cmUtbmFtZVwiPkFjY29tLjwvc3Bhbj5cbiAgICAgICAgPGRpdiBjbGFzcz1cImZvcm0tZmllbGRcIj5cbiAgICAgICAgICAgIDxpbnB1dCB0eXBlPVwidGV4dFwiIG5hbWU9XCJ7eyhpc0NsaWVudCA/ICdjbGllbnRfJyA6ICdpbnRlcnByZXRlcl8nKSArICdhY2NvbV8nICsgaW5kZXh9fVwiICNhY2NvbT1cIm5nTW9kZWxcIiBbcmVhZG9ubHldPVwiaXNSZWFkT25seVwiXG4gICAgICAgICAgICAgICAgICAgW3BsYWNlaG9sZGVyXT1cImFjY29tUGxhY2VIb2xkZXJcIiBjbGFzcz1cInBheXJvbGwtY2FyZF9fbWVhc3VyZS1pbnB1dFwiIFtuZ01vZGVsXT1cInBheXJvbGxJbnZvaWNlPy5hY2NvbW1vZGF0aW9uc1wiXG4gICAgICAgICAgICAgICAgICAgKG5nTW9kZWxDaGFuZ2UpPVwicGF5cm9sbEludm9pY2UuYWNjb21tb2RhdGlvbnMgPSAkZXZlbnRcIlxuICAgICAgICAgICAgICAgICAgIHBhdHRlcm49XCJcXCQ/KFxcZCt8XFxkKyhcXC58XFw6KVxcZCspXCI+XG4gICAgICAgICAgICA8c3BhbiAqbmdJZj1cImFjY29tLnRvdWNoZWQgJiYgKGFjY29tLmVycm9ycz8ucGF0dGVybik7XCJcbiAgICAgICAgICAgICAgICAgICBjbGFzcz1cImlubGluZS1pY29uIGVycm9yXCI+XG4gICAgICAgICAgICAgICAgICAgPHNwYW4+T29wcyEgT25seSBudW1lcmljYWwgdmFsdWVzLCBcIi5cIiBhbmQgXCI6XCIgYXJlIGFsbG93ZWQuPC9zcGFuPiFcbiAgICAgICAgICAgIDwvc3Bhbj5cbiAgICAgICAgPC9kaXY+XG4gICAgPC9kaXY+XG4gICAgPGRpdiBjbGFzcz1cInBheXJvbGwtY2FyZF9fbWVhc3VyZVwiPlxuICAgICAgICA8c3BhbiBjbGFzcz1cInBheXJvbGwtY2FyZF9fbWVhc3VyZS1uYW1lXCI+RmxpZ2h0czwvc3Bhbj5cbiAgICAgICAgPGRpdiBjbGFzcz1cImZvcm0tZmllbGRcIj5cbiAgICAgICAgICAgIDxpbnB1dCB0eXBlPVwidGV4dFwiIG5hbWU9XCJ7eyhpc0NsaWVudCA/ICdjbGllbnRfJyA6ICdpbnRlcnByZXRlcl8nKSArICdmbGlnaHRzXycgKyBpbmRleH19XCIgI2ZsaWdodHM9XCJuZ01vZGVsXCIgW3JlYWRvbmx5XT1cImlzUmVhZE9ubHlcIlxuICAgICAgICAgICAgICAgICAgIFtwbGFjZWhvbGRlcl09XCJmbGlnaHRzUGxhY2VIb2xkZXJcIiBjbGFzcz1cInBheXJvbGwtY2FyZF9fbWVhc3VyZS1pbnB1dFwiIFtuZ01vZGVsXT1cInBheXJvbGxJbnZvaWNlPy5mbGlnaHRzXCJcbiAgICAgICAgICAgICAgICAgICAobmdNb2RlbENoYW5nZSk9XCJwYXlyb2xsSW52b2ljZS5mbGlnaHRzID0gJGV2ZW50XCJcbiAgICAgICAgICAgICAgICAgICBwYXR0ZXJuPVwiXFwkPyhcXGQrfFxcZCsoXFwuKVxcZCspXCI+XG4gICAgICAgICAgICA8c3BhbiAqbmdJZj1cImZsaWdodHMudG91Y2hlZCAmJiAoZmxpZ2h0cy5lcnJvcnM/LnBhdHRlcm4pO1wiXG4gICAgICAgICAgICAgICAgICAgY2xhc3M9XCJpbmxpbmUtaWNvbiBlcnJvclwiPlxuICAgICAgICAgICAgICAgICAgIDxzcGFuPk9vcHMhIE9ubHkgbnVtZXJpY2FsIHZhbHVlcywgXCIuXCIgYW5kIFwiOlwiIGFyZSBhbGxvd2VkLjwvc3Bhbj4hXG4gICAgICAgICAgICA8L3NwYW4+XG4gICAgICAgIDwvZGl2PlxuICAgIDwvZGl2PlxuPC9mb290ZXI+XG4iLCI8YXBwLXBheXJvbGwtYWRkaXRpb25hbC1jb3N0cz48L2FwcC1wYXlyb2xsLWFkZGl0aW9uYWwtY29zdHM+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztNQ1FZO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFDaUM7SUFDMUI7SUFBTTtJQUE0RDs7Ozs7O01BV3pFO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFDaUM7SUFDMUI7SUFBTTtJQUE0RDs7Ozs7O01BV3pFO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFDaUM7SUFDMUI7SUFBTTtJQUE0RDs7Ozs7O01BV3pFO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFDaUM7SUFDMUI7SUFBTTtJQUE0RDs7Ozs7OztJQWpEckY7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO0lBQUE7Z0JBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtnQkFBQTtnQkFBQTtJQUE0SDtNQUN4SDtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQW1DO01BQy9CO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBeUM7SUFBZ0I7TUFDekQ7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUF3QjtJQUNwQjtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BRU87UUFBQTtRQUFBO01BQUE7TUFGUDtJQUFBO2dCQUFBOzs7TUFBQTtRQUFBOztNQUFBOztJQUFBO0tBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFBQTtNQUFBO0lBQUE7Z0JBQUE7TUFBQTtJQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtRQUFBOztNQUFBOztNQUFBO1FBQUE7O01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTs7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtnQkFBQTtnQkFBQTtJQUdxQztJQUNyQztnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBR087SUFDTDtJQUNKO01BQ047UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFtQztNQUMvQjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXlDO0lBQVk7TUFDckQ7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUF3QjtJQUNwQjtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BRU87UUFBQTtRQUFBO01BQUE7TUFGUDtJQUFBO2dCQUFBOzs7TUFBQTtRQUFBOztNQUFBOztJQUFBO0tBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFBQTtNQUFBO0lBQUE7Z0JBQUE7TUFBQTtJQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtRQUFBOztNQUFBOztNQUFBO1FBQUE7O01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTs7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtnQkFBQTtnQkFBQTtJQUd3QztJQUN4QztnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBR087SUFDTDtJQUNKO01BQ047UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFtQztNQUMvQjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXlDO0lBQWE7TUFDdEQ7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUF3QjtJQUNwQjtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BRU87UUFBQTtRQUFBO01BQUE7TUFGUDtJQUFBO2dCQUFBOzs7TUFBQTtRQUFBOztNQUFBOztJQUFBO0tBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFBQTtNQUFBO0lBQUE7Z0JBQUE7TUFBQTtJQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtRQUFBOztNQUFBOztNQUFBO1FBQUE7O01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTs7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtnQkFBQTtnQkFBQTtJQUd3QztJQUN4QztnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBR087SUFDTDtJQUNKO01BQ047UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFtQztNQUMvQjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXlDO0lBQWM7TUFDdkQ7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUF3QjtJQUNwQjtNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BRU87UUFBQTtRQUFBO01BQUE7TUFGUDtJQUFBO2dCQUFBOzs7TUFBQTtRQUFBOztNQUFBOztJQUFBO0tBQUE7a0JBQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFBQTtNQUFBO0lBQUE7Z0JBQUE7TUFBQTtJQUFBO2tCQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtRQUFBOztNQUFBOztNQUFBO1FBQUE7O01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTs7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtnQkFBQTtnQkFBQTtJQUdxQztJQUNyQztnQkFBQTs7O0lBQUE7T0FBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBR087SUFDTDtJQUNKO0lBQ0Q7Ozs7SUE5Q1U7SUFIUCxVQUdPLFVBSFA7SUFBbUI7SUFDbUU7SUFEdEYsVUFBbUIsV0FDbUUsVUFEdEY7SUFJTTtJQUFOLFVBQU0sVUFBTjtJQVlPO0lBSFAsVUFHTyxVQUhQO0lBQW1CO0lBQ3lEO0lBRDVFLFVBQW1CLFdBQ3lELFVBRDVFO0lBSU07SUFBTixVQUFNLFVBQU47SUFZTztJQUhQLFVBR08sVUFIUDtJQUFtQjtJQUN5RDtJQUQ1RSxVQUFtQixXQUN5RCxVQUQ1RTtJQUlNO0lBQU4sVUFBTSxVQUFOO0lBWU87SUFIUCxVQUdPLFVBSFA7SUFBbUI7SUFDMkQ7SUFEOUUsVUFBbUIsV0FDMkQsVUFEOUU7SUFJTTtJQUFOLFVBQU0sVUFBTjs7O0lBL0NaO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsU0FBQSxxRUFBQTtJQUlvSjtJQUNqSTtJQURQO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxVQUF3SSxVQUNqSSxVQURQLFVBQUEsNEVBQUE7SUFhMEc7SUFDbkc7SUFEUDtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsVUFBMEcsV0FDbkcsV0FEUCxXQUFBLDRFQUFBO0lBYTBHO0lBQ25HO0lBRFA7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBLFVBQTBHLFdBQ25HLFdBRFAsV0FBQSw0RUFBQTtJQWE4RztJQUN2RztJQURQO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQSxVQUE4RyxXQUN2RyxXQURQLFdBQUEsNEVBQUE7Ozs7O0lDM0NaO2dCQUFBOzs7SUFBQTs7Ozs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/booking-management/payroll-additional-costs/payroll-additional-costs.component.ngfactory.ts